import React from 'react';
import { Skeleton, Flex } from '@landr/maestro';
import { useWaveformData } from 'hooks/useWaveformData';
import PlayerButton from 'components/CommonUi/PlayerButton/PlayerButton';
import { SamplesTableWaveformProps } from './SamplesTableWaveform.types';
import { defaultRowContainer, playerButton } from './SamplesTablePlayer.styled';

export const SamplesTablePlayButtonSkeleton = () => (
    <Flex className={defaultRowContainer} justifyContent="center">
        <Flex className={playerButton}>
            <Skeleton width="sm" height="sm" variant="round" />
        </Flex>
    </Flex>
);

export const SamplesTablePlayButton: React.FC<SamplesTableWaveformProps> =
    React.memo(
        ({
            sampleGuid,
            sampleWaveformUrl,
            rowRef,
            interactWithPlayer = true,
        }) => {
            const { loading } = useWaveformData({
                sampleGuid,
                sampleWaveformUrl,
            });

            return loading ? (
                <SamplesTablePlayButtonSkeleton />
            ) : (
                <Flex className={defaultRowContainer} justifyContent="center">
                    <Flex className={playerButton}>
                        <PlayerButton
                            isRounded
                            variant="ghost"
                            size="sm"
                            id={sampleGuid}
                            interactWithPlayer={interactWithPlayer}
                            preventDefault={interactWithPlayer}
                            stopPropagation={interactWithPlayer}
                            keyboardEventConsumerRef={rowRef}
                        />
                    </Flex>
                </Flex>
            );
        },
        (prevProps, nextProps) => {
            // Compare each prop individually
            return (
                prevProps.sampleGuid === nextProps.sampleGuid &&
                prevProps.sampleWaveformUrl === nextProps.sampleWaveformUrl &&
                prevProps.rowRef === nextProps.rowRef &&
                prevProps.interactWithPlayer === nextProps.interactWithPlayer
            );
        },
    );
